import { useState } from "react";
import { useSwivuBryntumContext } from "./useSwivuBryntumContext";
import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys";

export const useWarRoom = (postfix: string) => {
  const { userPreferences } = useSwivuBryntumContext();
  const key = PERSISTENCE_STATE_KEYS.warRoomSizing + "-" + postfix;

  const [isWarRoom, setIsWarRoom] = useState(
    () => userPreferences?.getSetting(key) === "true"
  );

  const toggleWarRoom = (pressed: boolean) => {
    setIsWarRoom(pressed);
    userPreferences?.updateSetting(key, String(pressed));
  };

  return { isWarRoom, toggleWarRoom };
};
